// extracted by mini-css-extract-plugin
export default {"background":"wXXHX8","border":"eDDFv3","container":"UZJLP7","cards":"rULF5d","responsiveCards":"WkyYZe","loadMore":"zAOK0n","padding":"qyvevE"};